import React from "react"
import types from "prop-types"
import { FormIcon } from "shared/icons"
import { activityHubSubmissionPath } from "utils/routeHelpers"

const RelatedItemLink = ({ form, formSubmissionSlug = "" }) => {
  const { slug, title } = form
  let linkText
  let linkLocation

  if (formSubmissionSlug?.length > 0) {
    linkText = formSubmissionSlug
    linkLocation = activityHubSubmissionPath(formSubmissionSlug)
  } else if (title.length > 0) {
    linkText = title
    linkLocation = `/activity-hub/forms/${slug}/edit`
  }

  return (
    <a className="flex p-1.5 rounded items-center bg-light-100 text-sm text-black font-medium tracking-tight" target="_blank" href={linkLocation} rel="noreferrer">
      <FormIcon form={form} className="mr-2 h-6 w-6" />
      <div className="truncate">
        {linkText}
      </div>
    </a>
  )
}

RelatedItemLink.propTypes = {
  form: types.object.isRequired,
  formSubmissionSlug: types.string,
}

export default RelatedItemLink
